/**
 * @generated SignedSource<<5ad864d003383c4159dfd6efebed00ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateOkrsOnboardingSeenInput = {
  clientMutationId?: string | null;
  hasSeen: boolean;
};
export type ObjectiveListSetOkrOnboardingSeenOrSkippedMutation$variables = {
  input: UpdateOkrsOnboardingSeenInput;
};
export type ObjectiveListSetOkrOnboardingSeenOrSkippedMutation$data = {
  readonly setOkrOnboardingSeenOrSkipped: {
    readonly ok: boolean | null;
  } | null;
};
export type ObjectiveListSetOkrOnboardingSeenOrSkippedMutation = {
  response: ObjectiveListSetOkrOnboardingSeenOrSkippedMutation$data;
  variables: ObjectiveListSetOkrOnboardingSeenOrSkippedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateOkrsOnboardingSeenPayload",
    "kind": "LinkedField",
    "name": "setOkrOnboardingSeenOrSkipped",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ObjectiveListSetOkrOnboardingSeenOrSkippedMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ObjectiveListSetOkrOnboardingSeenOrSkippedMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "31ff1a65df83a98909a82f9407ef283c",
    "id": null,
    "metadata": {},
    "name": "ObjectiveListSetOkrOnboardingSeenOrSkippedMutation",
    "operationKind": "mutation",
    "text": "mutation ObjectiveListSetOkrOnboardingSeenOrSkippedMutation(\n  $input: UpdateOkrsOnboardingSeenInput!\n) {\n  setOkrOnboardingSeenOrSkipped(input: $input) {\n    ok\n  }\n}\n"
  }
};
})();

(node as any).hash = "15e2e89ae0c579b32c3755b35e719fa2";

export default node;
